<template>
   <v-container>
     <img :src="athlete.profile" />
     <h4>{{ `${athlete.firstname} ${athlete.lastname}` }}</h4>
   </v-container>
</template>

<script>
  export default {
    props: {
       athlete: {
         type: Object,
         default: () => null,
       },
    },
    data: () => ({
    }),
    methods:
    {
    },
  };
</script>

<style>

</style>
